module.exports = __webpack_public_path__ + "img/Flag_of_Poland.1f9d98ad.svg";